// Created by hejikun on 2017/10/25 0025.
let state = {
  zip_upload_cache: [], // 选择文件
  zip_upload_cache_compress: [],
  zip_upload_cache_origin: [],
  zip_paths: [],
  zip_status: 'ready' // 上传状态 ready selected uploading finished
}

const actions = {}

const getters = {}

const mutations = {
  set_zip_upload_cache(state, arg) {
    state.zip_upload_cache = arg
  },
  set_zip_upload_cache_compress(state, arg) {
    state.zip_upload_cache_compress = arg
  },
  set_zip_upload_cache_origin(state, arg) {
    state.zip_upload_cache_origin = arg
  },
  set_zip_paths(state, arg) {
    state.zip_paths = arg
  },
  set_zip_status(state, arg) {
    state.zip_status = arg
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
